import { useEffect, useRef, useState } from 'react';

export const useMeetingVideo = () => {
  const [isFullscreen, setFullscreen] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);

  const handlePlayVideo = () => {
    setFullscreen((prevState) => !prevState);
  };

  const handleClose = () => {
    if (videoRef?.current) {
      (videoRef.current as HTMLVideoElement)?.pause();
    }
    setFullscreen(false);
  };

  useEffect(() => {
    const handleCloseVideo = (event: any) => {
      if (event.code === 'Escape' && videoRef?.current) {
        setFullscreen(false);
        (videoRef.current as HTMLVideoElement)?.pause();
      }
    };
    document.addEventListener('keydown', handleCloseVideo);

    return () => {
      document.removeEventListener('keydown', handleCloseVideo);
    };
  }, []);

  useEffect(() => {
    if (videoRef?.current) {
      videoRef.current.volume = 0.2;
    }
  }, []);

  return {
    handlePlayVideo,
    isFullscreen,
    handleClose,
    videoRef,
  };
};
